import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { ComingSoon } from './pages/ComingSoon';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3k9b0pqx7f3wg">
      <Routes data-id="element-1" data-mp="3k9um5hm2caf8">
        <Route path="/" element={<Home data-id="element-3" data-mp="3k8t6ezu3qzr6" />} data-id="element-2" data-mp="3k89rlrzr0rhd" />
        <Route path="*" element={<ComingSoon data-id="element-5" data-mp="3f9yi5idd8izo" />} data-id="element-4" data-mp="3k78bva7sfgtb" />
      </Routes>
    </BrowserRouter>;
}